import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'spinner-cover',
  templateUrl: './spinner-cover.component.html',
  styleUrls: ['./spinner-cover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SpinnerComponent],
})
export class SpinnerCoverComponent {
  @Input() public isLoading: boolean;
}
